import MobileDetect from "mobile-detect"

;(() => {
  const mobileDetect = new MobileDetect(window.navigator.userAgent)
  const isTouchScreen =
    !!mobileDetect.mobile() || !!mobileDetect.tablet() || !!mobileDetect.phone()

  const subNavOpenClass = "sub-nav-open"
  const subSubNavOpenClass = "sub-sub-nav-open"
  const siteNavOpenClass = "site--main-nav-open"

  function closeSubNav(nav) {
    nav.classList.remove(subNavOpenClass)
    nav.parentElement.parentElement.classList.remove(subSubNavOpenClass)

    for (const link of nav.querySelectorAll(`.${subNavOpenClass}`)) {
      link.classList.remove(subNavOpenClass)
    }
  }

  function initSubNav() {
    const header = document.getElementById("header")
    const mainNav = document.querySelector(".main-nav__list")

    if (!header || !mainNav) {
      return
    }

    const subNavLinks = mainNav.querySelectorAll(
      ".has-sub-nav > a, .has-sub-nav > span",
    )
    const noSubNavLinks = mainNav.querySelectorAll(
      ".main-nav__item:not(.has-sub-nav) a",
    )

    for (const link of subNavLinks) {
      if (isTouchScreen) {
        link.addEventListener("click", (e) => {
          e.preventDefault()

          const isOpen = link.parentElement.classList.contains(subNavOpenClass)

          closeSubNav(link.parentElement.parentElement)

          if (!isOpen) {
            link.parentElement.parentElement.classList.add(subNavOpenClass)
            link.parentElement.classList.toggle(subNavOpenClass)

            const parentSubNav = link.parentElement.parentElement.closest(
              ".has-sub-nav.sub-nav-open",
            )

            if (parentSubNav) {
              parentSubNav.classList.add(subSubNavOpenClass)
            }
          }
        })
      } else {
        link.addEventListener("mouseenter", () => {
          closeSubNav(link.parentElement.parentElement)

          mainNav.classList.add(subNavOpenClass)
          link.parentElement.classList.toggle(subNavOpenClass)
        })
      }
    }

    if (!isTouchScreen) {
      for (const link of noSubNavLinks) {
        link.addEventListener("mouseenter", () => {
          closeSubNav(link.parentElement.parentElement)
        })
      }

      mainNav.addEventListener("mouseleave", (event) => {
        closeSubNav(mainNav)
      })
    }
  }

  function initMainNav() {
    const headerNav = document.querySelector(".header__nav")
    const mainNav = document.querySelector(".main-nav__list")
    const button = document.getElementById("menu-toggle")
    const topNotification = document.getElementById("top-notification")

    if (!button || !headerNav || !mainNav) {
      return
    }

    const html = document.querySelector("html")
    let scrollPosition = 0

    button.addEventListener("click", () => {
      const scrollY = window.scrollY

      if (!html.classList.contains(siteNavOpenClass)) {
        scrollPosition = scrollY
      }

      closeSubNav(mainNav)
      html.classList.toggle(siteNavOpenClass)

      if (html.classList.contains(siteNavOpenClass)) {
        const offsetTop =
          topNotification && scrollY < topNotification.offsetHeight
            ? topNotification.offsetHeight - scrollY
            : 0

        topNotification.style.marginTop = `${offsetTop - topNotification.offsetHeight}px`

        setTimeout(() => {
          headerNav.style.maxHeight = `calc(${window.innerHeight}px - 60px - ${offsetTop}px)`
        }, 60)
      } else {
        topNotification.style.marginTop = null
        window.scrollTo(0, scrollPosition)
      }
    })
  }

  window.addEventListener("DOMContentLoaded", () => {
    initMainNav()
    initSubNav()
  })
})()
